
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PhysicianExperienceParameter  extends Parameter{

    searchTerm: number;
    orderBy: string;
}

export interface PhysicianExperience {

    id?: number;
    hospitalName:string;
    startDate:Date;
    endDate:Date;  
    experienceInYear:string;   
    designationId:any;   
    physicianId:any;    
     
    tenantId: any;
    branchId: any;
    
    parameters?: PhysicianExperienceParameter[];
    links?: any;

}

export abstract class PhysicianExperienceData { 

    abstract list(url: string): Observable<PhysicianExperience[]>;
    abstract create(url: string, data: PhysicianExperience[]): Observable<any>;
    abstract update(url: string, data: PhysicianExperience): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}
